import { RequireAutorization } from './routerAuth'
const Companies = () => import(/* webpackChunkName: "companies" */ '@/components/companies/Index.vue')
const CompanyNew = () => import(/* webpackChunkName: "companies" */ '@/components/companies/New.vue')

export const ROUTE_COMPANIES = [{
  name: 'Companies',
  path: '/empresas',
  component: Companies,
  meta: { title: 'Empresas' },
  children: [
    {
      name: 'CompanyNew',
      path: 'criar',
      component: CompanyNew,
      meta: { title: 'Cadastrar Empresa' },
      beforeEnter: RequireAutorization
    }
  ],
  beforeEnter: RequireAutorization
}]
